import { DragEvent } from 'react';
import { logError } from 'setup/logger/logError';

export enum InternalDragType {
  DOCUMENTATION_ITEM = 'documentation-item',
}

export interface InternalDragData<T = unknown> {
  type: InternalDragType;
  item: T;
  items?: T[];
}

export function isInternalDataDrag(e: DragEvent<Element>): boolean {
  return e.dataTransfer?.types.includes('text/plain') ?? false;
}

export function parseInternalDragData<T extends InternalDragData>(
  e: DragEvent<Element>
): T | null {
  try {
    const data = e.dataTransfer?.getData('text/plain');
    if (!data) return null;
    return JSON.parse(data) as T;
  } catch (error) {
    logError('Error parsing internal drag data:', error);
    return null;
  }
}

export function setInternalDragData<T extends InternalDragData>(
  e: DragEvent<Element>,
  data: T
): void {
  e.dataTransfer?.setData('text/plain', JSON.stringify(data));
}

export function isInternalDragOfType<T>(
  dragData: unknown,
  type: InternalDragType
): dragData is InternalDragData<T> {
  return (
    typeof dragData === 'object' &&
    dragData !== null &&
    'type' in dragData &&
    (dragData as InternalDragData<T>).type === type
  );
}
